import dayjs from 'dayjs';

import { Button, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
import Chip from '@mui/material/Chip';

import { useEnumApi } from 'contexts/EnumApiContext';
import { ROLE } from 'data/data';
import { patchAttentionObservationsRelease } from 'components/axios/equipmentAlertsAxios';
import MainCard from 'components/MainCard';
import FileDownloadIcon from 'components/FileDownloadIcon';
import useModals from 'components/modals/useModal';
import { modals } from 'components/modals/Modals'; 
import AttentionObservationRequestLayer from 'components/layer/AttentionObservationRequestLayer';
import { useTranslation } from 'react-i18next';

const AttentionObservationInfoCard = ({attentionObservation, setIsLoading : setParentIsLoading}) => {
    const { role, getEnumValueByEnumNameAndCode } = useEnumApi();
    const { t } = useTranslation();

    const today = new Date();
    const todayNum = dayjs(today).format("YYYYMMDD");

    // modal 관련
    const { openModal } = useModals();

    const risUserModal = (id) => {
        openModal(modals.promptModal, {
            onSubmit : (value) => {
                let body = {
                    id,
                    risUser : value
                }
                patchAttentionObservationsRelease(id, body).then((res) => {
                    setParentIsLoading(false);
                })
            },
            onClose : () => {
                console.log('close');
            },
            message: t('message.common.alert.release.handler.input'),
            originValue : ''
            //label : '비고'
        });
    }

    if (attentionObservation) {
        // console.log(attentionObservation)
        let statusColor = '';
        let observeStatusCode = '';
        let statusName = '';
        //console.log(endYmd);
        if (attentionObservation.status) {
            observeStatusCode = attentionObservation.status;
            statusName = getEnumValueByEnumNameAndCode("AttentionObservationStatus", attentionObservation.status)?.[0]?.title;
            if (attentionObservation.status === 'V') {
                statusColor = "condition1";
            } else {
                statusColor = "condition4";
            }
        }

        // if (attentionObservation.endYmd) {
        //     let endYmd = attentionObservation.endYmd.replaceAll('-','');
        //     if (endYmd >= todayNum) { // 유효
        //         statusColor = "condition1";
        //         observeStatusCode = "V";
        //         statusName = t('message.common.text.available');
        //     } else {  // 해제
        //         statusColor = "condition4";
        //         observeStatusCode = "R";
        //         statusName = t('message.common.text.release');
        //     }
        // } else {
        //     statusColor = "condition1";
        //     observeStatusCode = "V";
        //     statusName = t('message.common.text.available');
        // }

      return (
        <>
            <div className='alert_phrase'>
                <MainCard className="center_table" content={false}>
                    <div className="stpes" style={{display:"flex", alignItems:"center", backgroundColor:"#353535", flexWrap:"wrap"}}>
                      <span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/subway1.png`} alt='' /></span>&nbsp;
                        <Chip label={t('message.common.btn.observe')} color="success" style={{backgroundColor:'#e7c748'}} />
                        <TableContainer>
                        <Table sx={{ minWidth: 500 }} aria-label="simple table" className="same_width" style={{borderCollapse:"unset", borderSpacing:"revert"}}>
                            <TableBody>
                            <TableRow>
                                <TableCell className="th" align="center">{t('message.common.subtitle.observe.startYmd')}</TableCell>
                                <TableCell align="center">{attentionObservation.regYmd}</TableCell>
                                <TableCell className="th" align="center">{t('message.common.subtitle.observe.endYmd')}</TableCell>
                                <TableCell align="center">{attentionObservation.endYmd}</TableCell>
                                <TableCell className="th" align="center">{t('message.common.subtitle.observe.release.date')}</TableCell>
                                <TableCell align="center">{attentionObservation.risYmd}</TableCell>
                                {/* <TableCell className="th" align="center">주의관찰 기간</TableCell>
                                <TableCell align="center"></TableCell> */}
                            </TableRow>
                            <TableRow>
                                <TableCell className="th" align="center">{t('message.common.subtitle.observe.detail')}</TableCell>
                                <TableCell className="pl" colSpan={5} style={{textAlign:"left"}}>
                                {attentionObservation.remark}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell className="th" align="center">{t('message.common.subtitle.observe.regUser')}</TableCell>
                                <TableCell align="center">{attentionObservation.regUser}</TableCell>
                                <TableCell className="th" align="center">{t('message.common.subtitle.createdate')}</TableCell>
                                <TableCell align="center">{attentionObservation.regYmd}</TableCell>
                                <TableCell className="th" align="center">{t('message.common.subtitle.status')}</TableCell>
                                <TableCell align="center">
                                    <div className={statusColor}>{statusName}</div>
                                </TableCell>
                            </TableRow>
                            {attentionObservation.risYmd && attentionObservation.risUser &&
                            <TableRow>
                                <TableCell className="th" align="center">{t('message.common.subtitle.release.handler')}</TableCell>
                                <TableCell align="center">{attentionObservation.risUser}</TableCell>
                                <TableCell className="th" align="center">{t('message.common.subtitle.release.date')}</TableCell>
                                <TableCell colSpan={3} align="center">{attentionObservation.risYmd}</TableCell>
                            </TableRow>
                            }
                            {attentionObservation.statusReport && (attentionObservation.statusReport.reportUser || attentionObservation.statusReport.reportYmd) &&
                            <TableRow>
                                <TableCell className="th" align="center">{t('message.common.subtitle.status.reporter')}</TableCell>
                                <TableCell align="center">{attentionObservation.statusReport.reportUser}</TableCell>
                                <TableCell className="th" align="center">{t('message.common.subtitle.status.report.date')}</TableCell>
                                <TableCell colSpan={3} align="center">{attentionObservation.statusReport.reportYmd}</TableCell>
                            </TableRow>
                            }
                            {attentionObservation.statusReport && attentionObservation.statusReport.reportDtl &&
                            <TableRow>
                                <TableCell className="th" align="center">{t('message.common.subtitle.status.report.detail')}</TableCell>
                                <TableCell className="pl" colSpan={5} style={{textAlign:"left"}}>
                                {attentionObservation.statusReport.reportDtl}
                                </TableCell>
                            </TableRow>
                            }
                            {attentionObservation.statusReport && attentionObservation.statusReport.reportFiles &&
                            <TableRow>
                                <TableCell className="th" align="center">{t('message.common.subtitle.status.report.file')}</TableCell>
                                <TableCell className="pl" colSpan={5} style={{textAlign:"left"}}>
                                {attentionObservation.statusReport.reportFiles.map(function(file, idx){
                                return (
                                <div key={idx}><FileDownloadIcon file={file} viewFileName={true}/>{(attentionObservation.statusReport.reportFiles-1)>idx && <br/>}</div>
                                )                      
                                })}
                                </TableCell>
                            </TableRow>
                            }
                            </TableBody>
                        </Table>
                        </TableContainer>
                    </div>
                </MainCard>
                { role !== ROLE.MO.code &&
                <div className="btn_right">
                    <AttentionObservationRequestLayer alertId={attentionObservation.equipmentAlert.id} setIsLoading={setParentIsLoading} type="modify" />
                    {observeStatusCode === 'V' && 
                    <>
                    &nbsp;&nbsp;
                    <Button variant="contained" onClick={()=>{risUserModal(attentionObservation.id)}}>{t('message.common.text.release')}</Button>
                    </>
                    }
                </div>
                }
            </div>
        </>
      )
    }
}

export default AttentionObservationInfoCard;